/* eslint-disable no-plusplus */
import { Detector, EventListenerCallback, OnDetectionCallback } from '../types';

class InputDetector<T> implements Detector<T> {
  eventListenerCallback: EventListenerCallback | null;

  onDetection: OnDetectionCallback<T>;

  constructor(
    onDetection?: OnDetectionCallback<T>,
  ) {
    this.onDetection = (...args) => {
      onDetection?.apply(this, args);
    };
    this.eventListenerCallback = null;
  }

  start() {
    if (this.eventListenerCallback) {
      return this;
    }
    this.eventListenerCallback = (e: Event) => {
      const element = e.target as HTMLInputElement;
      if (element?.type && element?.value) {
        const startTime = Date.now();
        // let value;
        // switch (element.type) {
        //   case 'radio':
        //   case 'checkbox':
        //     value = element.checked ? 'true' : 'false';
        //     break;
        //   default:
        //     value = element.value;
        // }
        window.requestAnimationFrame(() => {
          this.onDetection(element, e, startTime);
        });
      }
    };
    document.addEventListener('input', this.eventListenerCallback);
    return this;
  }

  stop() {
    if (this.eventListenerCallback) {
      document.removeEventListener('input', this.eventListenerCallback);
      this.eventListenerCallback = null;
    }
    return this;
  }
}

export default InputDetector;
